module.exports = __webpack_public_path__ + "img/tips.e6e31119.svg";